import { Directive, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { Register } from 'src/app/common-components/register/models/register';
import { getDevicePrivileges } from 'src/app/privileges/privileges.selector';
import { DevicesFilterOption } from './models/device-filter-option';
import { DevicePrivileges } from './models/device-privileges';
import { DeviceRegisterOptions } from './models/device-register-options';
import { DeviceRegisterListItem } from './models/device-register-results.model';
import {
   createDevice,
   deviceRegisterAdapterActions,
   deviceRegisterInitialFilter,
} from './state/device-register.actions';
import * as deviceRegisterReducer from './state/device-register.reducer';
@Directive()
export class DeviceRegister
   extends Register<DeviceRegisterListItem, DeviceRegisterOptions, OrderingOption>
   implements OnInit
{
   columns: string[];

   filters: DevicesFilterOption[];

   entityName = 'Phone';

   devicePrivileges$: Observable<DevicePrivileges>;

   isSystemUser$: Observable<boolean>;

   constructor(public store: Store) {
      super(store, deviceRegisterReducer.selectors, deviceRegisterAdapterActions);
      this.devicePrivileges$ = store.pipe(select(getDevicePrivileges));
   }

   ngOnInit() {
      this.store.dispatch(deviceRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(this.actions.pageEnter());
   }

   onCreate(): void {
      this.store.dispatch(createDevice());
   }
}
